export default "__VITE_ASSET__$QmBktPz__"